import ApproachSection from "./ApproachSection";
import EngagementProcess from "./EngagementProcess";
import ExpertiseSection from "./ExpertiseSection";
import FixedVideoBackground from "./FixedVideoBackground";
import FragmentationImpact from "./FragmentationImpact";
import HeroNew from "./HeroNew";
import Pricing from "./Pricing";
import ReferencesSection from "./ReferencesSection";
import ResearchSection from "./ResearchSection";
import ServicesSection from "./ServicesSection";

import { PageSEO } from "@/components/SEO/PageSEO";
import {
  generateOrganizationSchema,
  generateLocalBusinessSchema,
  generateServicesListSchema,
  generateWebSiteSchema,
} from "@/utils/structuredData";

const HomePage = () => {
  // Generate structured data for homepage
  const structuredData = [
    generateOrganizationSchema(),
    generateLocalBusinessSchema(),
    generateServicesListSchema(),
    generateWebSiteSchema(),
  ];

  return (
    <>
      <PageSEO
        title="Break the Profitability Paradox"
        description="Scale revenue without sacrificing margins through AI-powered automation. Custom ERP integration, workflow automation, and intelligent business process optimization with milestone-based pricing and enterprise-grade execution."
        keywords="AI automation, business automation, ERP integration, workflow optimization, custom software development, profitability paradox, operational efficiency, data analytics, business intelligence, process automation"
        ogImage="/og-image-homepage.png"
        structuredData={structuredData}
      />

      {/* Fixed video background visible through gaps between sections */}
      <FixedVideoBackground />

      <div className="homepage relative min-h-screen py-8 space-y-8 sm:py-12 sm:space-y-12 lg:py-16 lg:space-y-16">
        {/* Hero - Floating card like other sections */}
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <HeroNew />
        </div>

        {/* Profitability Paradox - Combined section */}
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <ResearchSection />
        </div>

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <FragmentationImpact />
        </div>

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <ApproachSection />
        </div>

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <ExpertiseSection />
        </div>

        {/* Services Section - What We Build */}
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <ServicesSection />
        </div>

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <EngagementProcess />
        </div>

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <Pricing />
        </div>

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
          <ReferencesSection />
        </div>
      </div>
    </>
  );
};

export default HomePage;
